module.exports = {
  revolver: {
    name: "revolver",
    speed: 500,
  },
};
